import { FontFamily } from '@euler/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { HeaderTitle } from '@react-navigation/elements';
import color from 'color';
import { StyleProp, Text, TextStyle, View } from 'react-native';
import { useTheme } from 'styled-components';

type Props = Parameters<typeof HeaderTitle>[0] & {
  subTitleStyle?: StyleProp<TextStyle>;
};

export const MultilineHeaderTitle = ({ subTitleStyle, ...props }: Props) => {
  const theme = useTheme();
  const { rpx } = useResponsiveContext();

  if (typeof props.children !== 'string') {
    return <></>;
  }
  if (props.children.includes('\n')) {
    const [title, subtitle] = props.children!.split('\n');
    // $hack(eric): allow use directive/modifier in form of
    // `!color[#aabbcc] text` to set the sub title color.
    const m = subtitle ? /^!color\[(.+?)\]\s(.+?)$/.exec(subtitle) : null;
    const subTitleColor =
      m?.[1] ??
      (props.tintColor
        ? color(props.tintColor).fade(0.6).string()
        : theme.page.header.subTitleColor);
    const subTitle = m?.[2] ?? subtitle;
    return (
      <View
        css={`
          align-items: center;
        `}
      >
        <HeaderTitle {...props}>{title}</HeaderTitle>
        <Text
          style={subTitleStyle}
          css={`
            font-family: ${FontFamily.NotoSans.Light};
            font-size: ${rpx(12)}px;
            line-height: ${rpx(14)}px;
            color: ${subTitleColor};
          `}
        >
          {subTitle}
        </Text>
      </View>
    );
  }
  return <HeaderTitle {...props} />;
};

export const MultilineHeaderTitleFactory = (options: {
  subTitleStyle?: StyleProp<TextStyle>;
}) => {
  return (props: Props) => <MultilineHeaderTitle {...props} {...options} />;
};
